/* eslint-disable @typescript-eslint/member-ordering */
/* eslint-disable complexity */
/* eslint-disable no-param-reassign, @typescript-eslint/no-this-alias*/
import { observable, transaction } from 'mobx';
import { generate } from 'shortid';
import { UIModelType } from '@src/slide/domain/ui-model/element-modeles/constant';
import { IModelHandler } from '@src/slide/domain/ui-model/changesetManager/changesetEngine';
import ChangesetEngineV3 from '@src/slide/domain/ui-model/changesetManager/changeset-engine-v3';
import BaseConvert from '@src/slide/domain/ui-model/element-modeles/convert/baseConvert';
//  lodash部分引入
import _isObject from 'lodash/isObject';
import _has from 'lodash/has';
import _set from 'lodash/set';
/** 接口及类型引入 */
import {
    IBaseExtensions,
    IBaseModel,
    ISelectedByOtherInfo,
    IUpdateAndRemoveProps,
} from '@src/slide/domain/ui-model/element-modeles/Interface/base/base-model.interface';
import type { ISlideModel } from '@src/slide/domain/ui-model/element-modeles/Interface/slide-model.interface';
import type { ILayoutModel } from '@src/slide/domain/ui-model/element-modeles/Interface/layout-model.interface';
import type { IMasterModel } from '@src/slide/domain/ui-model/element-modeles/Interface/master-model.interface';
import type { ITask } from '@src/slide/infrastructure/module/dependent/taskManager/ITask';
import type { IPresentationModel } from '@src/slide/domain/ui-model/element-modeles/Interface/presentation-model.interface';
import type { IBaseModelProps } from '@src/slide/domain/ui-model/element-modeles/Interface/model-props/base-model-props.interface';
import { SourceType } from '@src/slide/domain/ui-model/constant/element-source';
import { PPTEditorStateType } from '@src/slide/domain/ui-model/constant/edit-state-type';
import { toJSON } from '@src/slide/infrastructure/module/independent/object-operation';
import { AppServiceProvider } from '@src/slide/application/app-service-provider';
import { browser } from '@src/slide/infrastructure/module/independent/agent/common';
import type { ISelectionService } from '@src/slide/application/service/selection/selection-service.interface';
import type { IFontManager } from '@src/slide/content-viewer/service/font-manager/core/font-manager.interface';
import type { ISlideBaseAppServices } from '@src/slide/application/entry/toc/base/slide-base-app-services.interface';
import type { IMediaManager } from '@src/slide/application/service/media-manager/media-manager.interface';
import type { IMasterLayoutEditService } from '@src/slide/application/service/master-layout-edit-service/master-layout-edit-service.interface';
import type { IUserPriviledgeService } from '@src/slide/application/service/user-priviledge-service/user-priviledge-service.interface';
import type { IPcEditorAppServices } from '@src/slide/application/entry/toc/editor/pc/pc-editor-app-services.interface';
import type { ITipsManager } from '@src/slide/application/service/tips-manager/core/tips-manager.interface';
import type { ISelectedAnimManager } from '@src/slide/application/service/selection/selected-anim-manager.interface';
import type { IRightSideBarManager } from '@src/slide/application/service/right-side-bar-manager/right-side-bar-manager.interface';
import type { IAttachmentManager } from '@src/slide/application/service/attachment-upload/attachment-manager.interface';
import type { IMenuManager } from '@src/slide/application/service/menu-manager/menu-manager.interface';
import type {
    IObservableDataModel,
    DataModelChildListChange,
    DataModelInitChange,
    DataModelChange,
    ISlideProps,
    ISlideData,
    DataModel,
} from '@tencent/slide-sdk-model';
import {
    getChangedPart,
    getPathsFromObject,
    setLeafNodesToValue,
} from '@src/slide/infrastructure/module/independent/object/object-path';
import { changeArrAppendToSetOrModify } from '@src/slide/infrastructure/module/independent/object/arr-append-to-set-or-modify';
import { arrApplyNull } from '@src/slide/infrastructure/module/independent/object/arr-apply-null';
import { MutationSource, IBaseShapeDataModel } from '@tencent/slide-sdk-model';
import ModelModificationStash from '../../linkage-change-helper/model-modification-stash';
import { CopyModelHandler } from '../property/copy/copy-model';
import cloneDeep from 'lodash/cloneDeep';
import { tdw } from '@src/slide/infrastructure/module/dependent/report/offline-data-report/tdw-report';
import { RestrictedDataModel } from '@tencent/slide-sdk-model/src/model/data-model';

class BaseModel implements IBaseModel, IModelHandler {
    /**
     * Override Methods
     */
    public static convertDataUiToSdk(uiData, sdkData, rawUiModel, option?) {
        BaseConvert.convertDataUiToSdk(uiData, sdkData, rawUiModel);
    }

    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    public static willConvertDataSdkToUi(sdkData, uiData, rawSdk, option?) {}

    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    public static async convertDataSdkToUi(sdkData, uiData, rawSdkData, option?) {
        BaseConvert.convertDataSdkToUi(sdkData, uiData, undefined);
    }

    /**
     *
     * @param sdkData       用于转换使用的SDK 数据 不一定是binding 的SDK 数据
     * @param uiData        转换到的目标的UImodel 数据
     * @param rawSdkData    UIModel binding 的SDK 数据
     */
    public static didConvertDataSdkToUi(sdkData, uiData, rawSdk, changesetInfo?) {}

    public static sdkV3UpdateProps(uiSdk, props): void {
        // 包含无用的set，剔除未变的属性 ( ?? uiSdk是为了兼容单元格 TableCellProps)
        const changedProps = getChangedPart((uiSdk.store ?? uiSdk).data, props);
        if (!Object.keys(changedProps).length) {
            return;
        }
        // 中台的对象属性如果是数组，想要删除的话只能置为空数组，用 null 无法删除
        arrApplyNull((uiSdk.store ?? uiSdk).data, props);
        // 中台默认传递array是append模式，上层纠正为set或者modify模式
        changeArrAppendToSetOrModify(props);
        // @ts-ignore  需要细化IBaseShapeDataModel
        (uiSdk as IBaseShapeDataModel)?.api?.updateProps(props);
    }

    public static sdkV3UpdateAndRemoveProps(uiSdk, sUpdateProps, sRemoveProps): void {
        const toRemovePaths = getPathsFromObject(sRemoveProps);
        toRemovePaths.forEach((path) => {
            if (!_has(sUpdateProps, path)) {
                _set(sUpdateProps, path, null);
            }
        });
        BaseModel.sdkV3UpdateProps(uiSdk, sUpdateProps);
    }

    public id = null; // SDK 数据ID 标识 （但不确保在同一个present model 根下不重复 只保证slide model 下不重复）
    public key = generate(); // React Component key字段使用
    public type: UIModelType; // 当前model 类型
    public parent: IBaseModel | null = null;
    // UIModel 绑定的 SDK Model
    public sdkData: RestrictedDataModel<DataModel> | null;
    public selectionService?: ISelectionService; // 数据对selection的依赖
    public pptEditorState: number;
    public hidden: number;
    public extensions: IBaseExtensions;
    @observable public children: any[] = [];
    @observable public selected = false; // 当前用户选中态
    @observable public selectedByOthers: null | ISelectedByOtherInfo[] = null; // 其他用户选中态
    private copyModelHandlerInstance: CopyModelHandler;

    public props: IBaseModelProps = {
        style: {
            left: 0,
            top: 0,
            width: 0,
            height: 0,
        },
    };

    // 子元素异步convert
    public asyncConvertChildren = true;

    // 变更信息的处理器
    public changeSetEngine = new ChangesetEngineV3(this);

    // 3.0 sdkData变更通知注册列表
    protected unsubscribeMap = new Map();

    public get sharedConvertTaskgroup(): null | ITask {
        let taskgroup: null | ITask = null;
        if (this.soruceRefForUI) {
            taskgroup = this.soruceRefForUI?.convertTaskGroup;
        } else if (this.presentationRef) {
            taskgroup = this.presentationRef.convertTaskGroup;
        }

        return taskgroup;
    }

    public get presentationRef(): IPresentationModel | null {
        let uiModel: any = this;
        while (uiModel && uiModel.type !== UIModelType.PRESENTATION) {
            uiModel = uiModel.parent;
        }
        return uiModel;
    }

    public get slideRef(): ISlideModel | null {
        let uiModel: any = this;
        while (uiModel && uiModel.type !== UIModelType.SLIDE) {
            uiModel = uiModel.parent;
        }
        return uiModel;
    }

    public get layoutRef(): ILayoutModel | null {
        let uiModel: any = this;
        while (uiModel && uiModel.type !== UIModelType.LAYOUT) {
            uiModel = uiModel.parent;
        }
        return uiModel;
    }

    public get masterRef(): IMasterModel | null {
        let uiModel: any = this;
        while (uiModel && uiModel.type !== UIModelType.MASTER) {
            uiModel = uiModel.parent;
        }
        return uiModel;
    }

    public get currentEditState() {
        let elementModel: any = this;
        while (elementModel) {
            if (elementModel?.pptEditorState) {
                return elementModel.pptEditorState;
            }
            elementModel = elementModel.parent;
        }
        return PPTEditorStateType.EDITABLE;
    }

    public constructor(props?: { selectionService?: ISelectionService }) {
        if (_isObject(props)) {
            if (props?.selectionService) {
                this.selectionService = props.selectionService;
            }
        }
    }

    /**
     * 当前 元素Model 属于 Slide Or Master Or Layout1
     * @returns {SourceType}
     */
    public get soruceTypeForUI(): string | null {
        if (this.type === UIModelType.SLIDE || this.slideRef) {
            return SourceType.SLIDE;
        }
        if (this.layoutRef) {
            return SourceType.LAYOUT;
        }
        if (this.masterRef) {
            return SourceType.MASTER;
        }
        return null;
    }

    /**
     * 当前 元素Model 属于哪个 Slide Or Master Or Layout
     * @returns {*}
     */
    public get soruceRefForUI(): ISlideModel | ILayoutModel | IMasterModel | null {
        if (this.slideRef) {
            return this.slideRef;
        }
        if (this.layoutRef) {
            return this.layoutRef;
        }
        if (this.masterRef) {
            return this.masterRef;
        }
        return null;
    }

    public async bindSDK(sdkData): Promise<void> {
        if (sdkData) {
            this.sdkData = sdkData;
            // 自身加入observer时优先级设置的要比默认高，因为还有slide监听layout的observer，这种的触发要在自身之后
            // 否则就会出现layout加减元素后，缩略图未更新（因为slide监听layout触发时，layout本身还未convert）
            this.addObserverTarget(sdkData, { priority: 1 });
            const promise = this.sdkOnDidChangeV3(sdkData);
            if (this.parent?.asyncConvertChildren) {
                await promise;
            }
        } else {
            this.unbindSDK();
        }
    }

    public dataModel?: IObservableDataModel<any, any>;

    public unbindSDK() {
        if (this.sdkData) {
            this.removeAllObserverTarget();
            this.sdkData = null;
        }
    }

    public clone(): IBaseModel {
        const objProto = Object.getPrototypeOf(this);
        const cloneModel = Object.assign(Object.create(objProto), this.cloneJsonObject());
        cloneModel.children = this.children.map((child: IBaseModel) => {
            const cloneChild = child.clone();
            cloneChild.parent = cloneModel;
            return cloneChild;
        });
        return cloneModel;
    }

    protected cloneJsonObject() {
        const cloneObj = { ...this };
        cloneObj.props = cloneDeep(this.props);
        return cloneObj;
    }

    public removeObserverTarget(sdkData) {
        if (this.unsubscribeMap.has(sdkData)) {
            this.unsubscribeMap.get(sdkData)();
            this.unsubscribeMap.delete(sdkData);
        }
    }

    public removeAllObserverTarget() {
        this.unsubscribeMap.forEach(e => e());
        this.unsubscribeMap.clear();
        this.children.forEach((item) => {
            item.removeAllObserverTarget();
        });
    }

    /**
     * 更新属性
     * @param {*} props 要变更的属性
     */
    public updateProps(props: any): void {
        if (!this.sdkData) return; // 解绑后为null
        window.log.info(`${Object.getPrototypeOf(this).constructor.name}updateProps`, toJSON(props));

        const sdkData = this.prepareSDKPropsData(props);
        BaseModel.sdkV3UpdateProps(this.sdkData, sdkData);
    }

    /**
     * 通过要修改的UI model props，返回update和remove的sdkModel props
     * @param props 要修改的props
     */
    public prepareUpdateAndRemoveSdkProps(props): IUpdateAndRemoveProps {
        const updateRemove = this.getUpdateAndRemoveProps(props);
        let updateSdkProps: any | null = null;
        let removeSdkProps: any | null = null;
        if (updateRemove) {
            if (updateRemove.update) {
                updateSdkProps = this.prepareSDKPropsData(updateRemove.update);
            }
            if (updateRemove.remove) {
                removeSdkProps = this.prepareSDKPropsData(updateRemove.remove);
            }
        } else {
            updateSdkProps = this.prepareSDKPropsData(props);
        }
        return { update: updateSdkProps, remove: removeSdkProps };
    }

    /**
     * 更新同时会删除属性，先做变更再做删除，记录一次undo
     * @param {*} updateProps 要变更的属性
     * @param {*} removeProps 要删除的属性
     */
    public updateAndRemoveProps(updateProps, removeProps?) {
        if (!this.sdkData) return; // 解绑后为null
        const sUpdateProps = this.prepareSDKPropsData(updateProps);
        const sRemoveProps = this.prepareSDKPropsData(removeProps);
        BaseModel.sdkV3UpdateAndRemoveProps(this.sdkData, sUpdateProps, sRemoveProps);
    }

    public removeProps(props): void {
        if (!this.sdkData) return; // 解绑后为null
        const sdkData = this.prepareSDKPropsData(props);
        setLeafNodesToValue(sdkData, null);
        BaseModel.sdkV3UpdateProps(this.sdkData, sdkData);
    }

    public updateBackgroundToImage(updateProps, removeProps?) {
        if (!this.sdkData) return; // 解绑后为null
        const sUpdateProps = this.prepareSDKPropsData(updateProps);
        const sRemoveProps = this.prepareSDKPropsData(removeProps);
        BaseModel.sdkV3UpdateAndRemoveProps(this.sdkData, sUpdateProps, sRemoveProps);
    }

    public updateSelectedByPatch(changeSet) {}

    /**
     * dom的id
     * @param regionType 表示不同区域
     * @returns {string}
     */
    public domId(regionType: string): string {
        return `${regionType}-${this.key}`;
    }

    public changesSaved(): boolean {
        return true;
    }

    public getMasterLayoutEditService(): IMasterLayoutEditService | undefined {
        if (browser.isMobile || !this.getUserPriviledgeService()?.isEditable()) {
            return undefined;
        }
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).editableServiceLayer
            ?.masterLayoutEditService;
    }

    public getSelectedAnims(): ISelectedAnimManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).editableServiceLayer
            ?.selectedAnims;
    }

    public getRightSideBarManager(): IRightSideBarManager | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices).editableServiceLayer
            ?.rightSideBarManager;
    }

    public async doConvertSdkDataModelToUiData(sdkData: IObservableDataModel, change?: DataModelChange) {
        Object.getPrototypeOf(this).constructor.willConvertDataSdkToUi(sdkData, this, sdkData, change);
        const promise = Object.getPrototypeOf(this).constructor.convertDataSdkToUi(sdkData, this, sdkData, change);
        if (this.parent?.asyncConvertChildren) {
            await promise;
        }
        Object.getPrototypeOf(this).constructor.didConvertDataSdkToUi(sdkData, this, sdkData, change);
    }

    public prepareSDKData(uiModel): any {
        const sdkData: any = {};
        Object.getPrototypeOf(this).constructor.convertDataUiToSdk(uiModel, sdkData, this);
        if (sdkData?.spPr?.prstGeom?.prst === null) {
            tdw({
                opername: 'quality_slide',
                module: 'convert',
                action: 'ui2sdk',
                ver6: JSON.stringify({
                    id: this.sdkData?.id,
                    padId: window.basicClientVars?.docInfo?.padInfo?.padId,
                    prepareSdk: sdkData,
                }),
            });
        }
        return sdkData;
    }
    public copyModelHandler(): CopyModelHandler {
        if (!this.copyModelHandlerInstance) {
            this.copyModelHandlerInstance = new CopyModelHandler(this);
        }
        return this.copyModelHandlerInstance;
    }

    /**
     * 设置扩展数据，针对单个 key 全量替换
     * @param key 扩展数据 key
     * @param value 扩展数据新 value
     */
    public setDataExtension(key: string, value: unknown): void {
        this.sdkData?.api.setDataExtension(key, JSON.stringify(value));
    }
    /**
     * 删除扩展数据
     * @param key 扩展数据 key
     */
    public removeDataExtension(key?: string): void {
        this.sdkData?.api.removeDataExtension(key);
    }

    /**
     * 3.0数据变更之后
     * @param sdkData
     * @param change
     * @protected
     */
    protected async sdkOnDidChangeV3(
        sdkData: IObservableDataModel,
        change?: DataModelChange & { source: MutationSource },
    ): Promise<void> {
        const promise = this.doConvertSdkDataModelToUiData(this.sdkData as IObservableDataModel, change);
        if (this.parent?.asyncConvertChildren) {
            await promise;
        }
        // 数据修改之后，清除暂存的改动
        ModelModificationStash.getInstance().clearModification(this.key);
    }

    /**
     * 监听sdk变更
     * @param sdkData
     * @protected
     */
    protected addObserverTarget(sdkData, options?): void {
        const { priority } = options || {};
        const unsubscribeHandler = sdkData?.subscribe?.((change: DataModelChange) => {
            this.sdkOnDidChangeV3WithTransaction(sdkData, change);
        }, { priority: priority || 0 });
        if (this.unsubscribeMap.has(sdkData)) {
            this.unsubscribeMap.get(sdkData)();
        }
        this.unsubscribeMap.set(sdkData, unsubscribeHandler);
    }

    // 子类继承实现，否则返回默认值
    protected getUpdateAndRemoveProps(updateProps): IUpdateAndRemoveProps {
        return { update: updateProps, remove: null };
    }

    protected prepareSDKPropsData(props): any {
        const uiModel = {
            props,
            parent: this.parent,
        };
        return this.prepareSDKData(uiModel);
    }

    private sdkOnDidChangeV3WithTransaction(sdkData, change: DataModelChange): void {
        if (this.sdkData !== sdkData) {
            // master/layout的文字颜色这种可继承的属性变更，在sdk处已经做了继承元素的subscribe通知，此处直接return
            // 而节点变更或者非继承属性，sdk不会通知，上层自己在slide-base-model加了subscribe注册，即master -> layout + slide    layout -> slide联动通知
            // 为了避免可继承的属性变更引发的重复sdkOnDidChange，此处把非节点变更以及showMasterSp以外的都忽略掉
            const needTriggerSlideRefresh =                (change as DataModelChildListChange)?.diffs?.childList
                || _has((change as DataModelInitChange<ISlideData, ISlideProps>)?.diffs?.data || {}, 'showMasterSp');
            if (!needTriggerSlideRefresh) {
                return;
            }
        }
        transaction(() => {
            this.changeSetEngine.storeChange(change);
            this.sdkOnDidChangeV3(sdkData, change);
            this.changeSetEngine.notifyChange();
        });
    }

    public setCurrentSlideIndex(index: number) {
        if (this.selectionService) {
            this.selectionService.currentSlideIndex = index;
        }
    }

    public getUpdateState() {
        return {};
    }

    public getFontManager(): IFontManager | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        if (appService?.viewableServiceLayer?.fontManager) {
            return appService.viewableServiceLayer.fontManager;
        }
        return undefined;
    }

    public getMediaManager(): IMediaManager | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        if (appService?.viewableServiceLayer?.mediaManager) {
            return appService.viewableServiceLayer.mediaManager;
        }
        return undefined;
    }

    public getAttachmentManager(): IAttachmentManager | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as IPcEditorAppServices;
        return appService.viewableServiceLayer.attachmentManager;
    }

    public getMenuManager(): IMenuManager | undefined {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        if (appService?.editableServiceLayer?.menuManager) {
            return appService.editableServiceLayer.menuManager;
        }
        return undefined;
    }

    public get initDatetime(): Date {
        const appService = AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices;
        return appService.getInfrastructureService().initDatetime;
    }

    private getUserPriviledgeService(): IUserPriviledgeService | undefined {
        return (AppServiceProvider.getInstance().getAppServices() as ISlideBaseAppServices).viewableServiceLayer
            .userPriviledgeService;
    }
}

export default BaseModel;
